import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

export abstract class BaseDao {
  constructor(private resource: string, public apiHelper: ApiHelper) {
    this.resource = resource;
  }

  public load(): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }

  public loadById(id: any): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/' + id;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }

  public getResource(): string {
    return this.resource;
  }

  public create(data: any): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, data, headers, null);
  }

  public update(obj: any, id?: string): Observable<any> {
    let _id = id ? id : ((obj['id'] as any) as string);
    let url: string = this.apiHelper.getServiceName() + this.getResource() + '/' + _id;
    let params = null;
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    delete obj['$type'];
    return this.apiHelper.apiCall(url, 'PUT', params, obj, headers);
  }

  public delete(id: string): Observable<any> {
    let url: string = this.apiHelper.getServiceName() + this.getResource() + '/' + id;
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    let params = null;
    let data = null;
    return this.apiHelper.apiCall(url, 'DELETE', params, data, headers);
  }
}
